import { warnIfFragment } from '../../utils/warnIfFragment';
import { DragHandleHoverContainerProvider } from './DragHandleHoverContainerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function DragHandleHoverContainer({
  children
}) {
  warnIfFragment(children, DragHandleHoverContainer.displayName);
  return /*#__PURE__*/_jsx(DragHandleHoverContainerProvider, {
    renderGripOnHover: true,
    children: children
  });
}
DragHandleHoverContainer.displayName = 'DragHandleHoverContainer';